
import { Component, Prop, Vue, Emit } from 'vue-property-decorator';

@Component
export default class Button extends Vue {
  @Prop({ type: String, default: 'button' }) public type!: string;
  @Prop({ type: Boolean, default: false }) public primary!: boolean;

  get classes() {
    return `button ${this.primary ? 'button--primary' : ''}`;
  }
}
